import React from 'react';
import Navigation from './Navigation';
import { UIProvider } from '@v2/shared/lib/ui';
import { Item } from '@v2/shared/lib/useAutoComplete';

type Props = Omit<React.ComponentProps<typeof Navigation>, 'searchCallback'>;

// The legacy mount (src/DMagzWeb/discountmags/components/Navigation) renders this
// inside a shadow root and injects dm-ui's prebuilt stylesheet, because on a legacy
// page Bootstrap would otherwise fight it. A V2 page loads no Bootstrap, so none of
// that is needed here — no react-shadow, no style injection, and no HeadlessUI
// portal redirect to work around the shadow boundary.
export default function NavigationMount(props: Props) {
  return (
    <UIProvider>
      <Navigation
        {...props}
        searchCallback={(item: Item) => {
          window.location.href = item.url || `/search?xSearch=${encodeURIComponent(item.title)}`;
        }}
      />
    </UIProvider>
  );
}
